<script lang="ts">
	import { Button, Text, type TextPropsTypes } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let title: string;
	export let description: string;
	export let btnText: string = null;
	export let onClick: () => void = null;
	export let loading = false; //Pako - added loading because sometimes we needed it
	export let withoutMargin = false;
	export let type: 'modal' | 'drawer' | 'page' = 'page';

	let titleStyleType: TextPropsTypes['styleType'] = 'h1';
	let descriptionStyleType: TextPropsTypes['styleType'] = 'body';

	$: if (type === 'modal' || type === 'drawer') {
		titleStyleType = 'body';
		descriptionStyleType = 'body-small';
	}
</script>

<div class="text-center">
	<Text
		class={classMap({
			'mb-s text-center': true,
			'text-bold': type === 'modal' || type === 'drawer',
		})}
		styleType={titleStyleType}
	>
		{title}
	</Text>
	<Text
		class={classMap({
			'mb-m': btnText,
			'text-center': true,
			'text-color-muted': true,
		})}
		styleType={descriptionStyleType}>{description}</Text
	>

	{#if btnText}
		<Button
			size={type === 'drawer' || type === 'modal' ? 'm' : 'l'}
			class={!withoutMargin ? 'mb-m' : ''}
			{loading}
			on:click={() => {
				onClick();
			}}
		>
			{btnText}
		</Button>
	{/if}
</div>
